export enum BlikPaymentStatusEnum {
  Error = 'error',
  Pending = 'pending',
  Rejected = 'rejected',
  Settled = 'settled',
}
